import { Component, OnInit, Input, ViewEncapsulation, Inject, EventEmitter, Output, OnDestroy } from '@angular/core';
import { UserInfoService } from '../../services/user-info.service';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

import { PrepopulatedFields } from '../interfaces/prepopulated-fields.interface';
import { ContentStorageService, GlobalShadowStyleDirective, PtlWindowLocationService } from '@ptl/global-components';
import { Subscription } from 'rxjs';
import { CommonLoginService } from '../../services/common-login.service';
import { LOGIN_STRATEGY, PtlLoginWrapperService } from '@ptl/account-management';

const LOGIN_PAGE_COMPONENT_CONTENT = 'LOGIN_PAGE_COMPONENT_CONTENT';
enum LOGIN_PAGE_COMPONENT_CONTENT_KEYS {
  REGISTRATION_URL = 'REGISTRATION_URL'
}
@Component({
    selector: 'app-login-page',
    templateUrl: './login-page.component.html',
    styleUrls: ['./login-page.component.scss'],
    encapsulation: ViewEncapsulation.ShadowDom,
    standalone: false
})
export class LoginPageComponent extends GlobalShadowStyleDirective implements OnInit, OnDestroy {
  @Input() unifiedLoginButtonLabel: string;
  @Input() unifiedLoginDescription: string;
  @Input() producerLandingPageUrl: string;
  @Input() forgotPasswordUrl: string;
  @Input() hideRegister: boolean;
  @Input() hideForgotPwd = false;
  @Input() loginStrategy: LOGIN_STRATEGY;

  contentSubscription: Subscription;
  registrationUrlContentStorage: string; // adding this to skip a deployment of AMS
  registrationUrl: string;

  /** In case we place this component inside of a modal, let's be able to communicate that we're closing */
  @Output() closeEmitter: EventEmitter<void> = new EventEmitter<void>();

  isModal = true;
  prepopulatedFields: PrepopulatedFields;

  constructor(
    private userInfoService: UserInfoService,
    private commonLoginService: CommonLoginService,
    private contentStorage: ContentStorageService,
    private windowLocationService: PtlWindowLocationService,
    private ptlLoginWrapper: PtlLoginWrapperService,
    @Inject(MAT_DIALOG_DATA) public matDialogData: {
      registrationStartUrl: string,
      loginStrategy: LOGIN_STRATEGY
    }
  ) {
    super();
    if (matDialogData && Object.keys(matDialogData).length === 0) {
      this.isModal = false;
    }
    /** If using this component as a modal, pass values via MAT_DIALOG_DATA injectionToken */
    for (const key in matDialogData) {
      if (matDialogData[key]) {
        this[key] = matDialogData[key];
      }
    }
  }

  ngOnInit() {
    this.registrationUrl = this.matDialogData.registrationStartUrl;

    this.contentSubscription = this.contentStorage.contentChanged$.subscribe(() => {
      const content = this.contentStorage.getContentMap(LOGIN_PAGE_COMPONENT_CONTENT) as Map<any, any>;
      if (content) {
        this.registrationUrlContentStorage = content.get(LOGIN_PAGE_COMPONENT_CONTENT_KEYS.REGISTRATION_URL);
        this.registrationUrl = this.registrationUrlContentStorage;
      }
    });

    // If a value was not passed for the strategy, wait for it to be set before showing login component
    // The login strategy is set in the global hidden component on page load
    if (!this.loginStrategy) {
      this.ptlLoginWrapper.currentLoginStrategy.subscribe((strategy) => {
        this.loginStrategy = strategy
      });
    }
  }

  ngOnDestroy() {
    if (this.contentSubscription) {
      this.contentSubscription.unsubscribe();
    }
  }

  async loginSuccess(event: any) {
    try {
      await this.commonLoginService.handleRedirectAfterLogin(this.producerLandingPageUrl);

      this.closeModal();
    }
    catch (e) {
      console.error(e);
    }
  }

  loginFail($event: any) {
    this.userInfoService.emitLoginFailure();
  }

  goToRegistrationPage() {
    if (this.registrationUrl) {
      this.windowLocationService.goToUrl(this.registrationUrl);
    }
  }

  closeModal() {
    this.closeEmitter.emit();
  }
}
